import React, { useEffect, useState } from "react";
import { Radio, RadioGroup, Button, ButtonGroup, cn, DateRangePicker, CalendarDate, RangeValue } from "@heroui/react";
import { I18nProvider, useDateFormatter } from "@react-aria/i18n";
import { parseDate } from "@internationalized/date";
import moment from "moment";

export type Props = Partial<{
  className: string;
  setStartDate: (date: any) => void;
  setEndDate: (date: any) => void;
  label?: string;
  startDate?: string;
  endDate?: string;
}>;

export const AfDateRangePicker: React.FC<Props> = ({ setStartDate, setEndDate, label, startDate, endDate }) => {
  let [date, setDate] = React.useState({
    start: parseDate(startDate || moment().startOf("day").subtract(1, "d").format("YYYY-MM-DD")),
    end: parseDate(endDate || moment().endOf("day").format("YYYY-MM-DD")),
  });
  const [isPickerOpen, setIsPickerOpen] = useState(false);

  useEffect(() => {
    if (date) {
      console.log("Selected Date Range:", date.start.toString(), "to", date.end.toString());
      setStartDate(date.start.toString());
      setEndDate(date.end.toString());
    }
  }, [date]);

  return (
    <div className="flex flex-col gap-4 ">
      <I18nProvider locale="en-GB">
        <DateRangePicker
          className=""
          label={label || ""}
          labelPlacement="inside"
          visibleMonths={3}
          value={date}
          onChange={setDate}
          variant="bordered"
          pageBehavior="single"
          isOpen={isPickerOpen} // Controlled open state
          onOpenChange={setIsPickerOpen} // Handle open/close
          content="asd"
          CalendarTopContent={
            <div className="flex gap-2 mb-2 justify-center p-1 font-inter">
              <Button
                size="sm"
                onPress={() => {
                  const today = moment();
                  const currentYear = today.year();
                  const currentMonth = today.month();
                  if (currentMonth >= 3) {
                    // currentMonth starts from 0
                    setDate({
                      start: parseDate(`${currentYear}-04-01`),
                      end: parseDate(`${currentYear + 1}-03-31`),
                    });
                  } else {
                    setDate({
                      start: parseDate(`${currentYear - 1}-04-01`),
                      end: parseDate(`${currentYear}-03-31`),
                    });
                  }
                  setIsPickerOpen(false);
                }}
              >
                This FY
              </Button>

              <Button
                size="sm"
                onPress={() => {
                  const today = moment();
                  const currentYear = today.year();
                  const currentMonth = today.month();
                  if (currentMonth >= 3) {
                    // currentMonth starts from 0
                    setDate({
                      start: parseDate(`${currentYear}-04-01`),
                      end: parseDate(`${currentYear + 1}-${today.subtract(1, "months").endOf("month").format("MM-DD")}`),
                    });
                  } else {
                    setDate({
                      start: parseDate(`${currentYear - 1}-04-01`),
                      end: parseDate(`${currentYear}-${today.subtract(1, "months").endOf("month").format("MM-DD")}`),
                    });
                  }
                  setIsPickerOpen(false);
                }}
              >
                FY to Last Month
              </Button>

              <Button
                size="sm"
                onPress={() => {
                  setDate({
                    start: parseDate(moment().startOf("day").format("YYYY-MM-DD")),
                    end: parseDate(moment().endOf("day").format("YYYY-MM-DD")),
                  });
                  setIsPickerOpen(false);
                }}
              >
                Today
              </Button>
              <Button
                size="sm"
                onPress={() => {
                  setDate({
                    start: parseDate(moment().startOf("day").subtract(1, "d").format("YYYY-MM-DD")),
                    end: parseDate(moment().endOf("day").subtract(1, "d").format("YYYY-MM-DD")),
                  });
                  setIsPickerOpen(false);
                }}
              >
                Yesterday
              </Button>
              <Button
                size="sm"
                onPress={() => {
                  setDate({
                    start: parseDate(moment().startOf("day").subtract(7, "d").format("YYYY-MM-DD")),
                    end: parseDate(moment().endOf("day").format("YYYY-MM-DD")),
                  });
                  setIsPickerOpen(false);
                }}
              >
                Last 7 Days
              </Button>
              <Button
                size="sm"
                onPress={() => {
                  setDate({
                    start: parseDate(moment().startOf("month").format("YYYY-MM-DD")),
                    end: parseDate(moment().endOf("month").format("YYYY-MM-DD")),
                  });
                  setIsPickerOpen(false);
                }}
              >
                This Month
              </Button>
              <Button
                size="sm"
                onPress={() => {
                  setDate({
                    start: parseDate(moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD")),
                    end: parseDate(moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD")),
                  });
                  setIsPickerOpen(false);
                }}
              >
                Last Month
              </Button>
            </div>
          }
        />
      </I18nProvider>
    </div>
  );
};
